import { useEffect, useCallback } from 'react';
import { useUser, useUserDispatch, UserTypes } from '../contexts/UserContext';
import { getTokenStatus } from '../utils/tokenManager';

/**
 * 단순 토큰 상태 체크를 위한 커스텀 훅 (갱신 없이)
 */
export const useTokenStatus = () => {
  const { profile, isLogin } = useUser();
  const dispatch = useUserDispatch();

  const checkTokenStatus = useCallback(async () => {
    if (!isLogin || !profile?.id) return;

    const userID = localStorage.getItem("userID");
    if (!userID) return;

    try {
      // 토큰 상태 확인 (갱신 없이)
      const tokenStatus = await getTokenStatus(userID);
      
      if (!tokenStatus.valid) {
        console.warn("⚠️ Long-lived token has expired, clearing session");
        dispatch({ type: UserTypes.CLEAR_PROFILE });
        return;
      }

      // 만료 임박 경고
      if (
        Number.isFinite(tokenStatus.daysUntilExpiry) &&
        tokenStatus.daysUntilExpiry <= 7
      ) {
        console.warn(`⏰ Long-lived token expires in ${tokenStatus.daysUntilExpiry} days`);
      }

    } catch (error) {
      console.error("Token status check failed:", error);
      // 토큰 체크 실패 시 세션 정리
      dispatch({ type: UserTypes.CLEAR_PROFILE });
    }
  }, [isLogin, profile, dispatch]);

  // 주기적 토큰 상태 체크 (30분마다)
  useEffect(() => {
    if (!isLogin) return;

    // 즉시 실행
    checkTokenStatus();

    // 30분마다 체크 (갱신이 없으므로 빈도 줄임)
    const interval = setInterval(checkTokenStatus, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, [isLogin, checkTokenStatus]);

  // 페이지 포커스 시 토큰 체크
  useEffect(() => {
    if (!isLogin) return;

    const handleFocus = () => {
      checkTokenStatus();
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [isLogin, checkTokenStatus]);

  return { checkTokenStatus };
};
